export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10701.e2181adf.jpg";